import React, { Component } from "react";
import { connect } from "react-redux";
import KeywordResearchSuggestionsModal from "../../components/KeywordResearch/KeywordResearchSuggestionsModal";
import { changeSelectedResearchType } from "../../store/keyword_research/creators";
import {
  getSelectedResearchType,
  getResearchTypes,
  getDefaultResearchType
} from "../../store/keyword_research/selectors";
import { getSelectedWebsiteRegionalDatabase } from "../../store/tracked_websites/selectors";

class KeywordResearchSuggestions extends Component {
  render() {
    return (
      <KeywordResearchSuggestionsModal
        openLabel={this.props.openLabel}
        modalTitle={this.props.modalTitle}
        keyword={this.props.keyword}
        seoDb={this.props.seoDb}
        onTypeChange={this.props.changeSelectedResearchType}
        defaultType={this.props.defaultType}
        selectedType={this.props.selectedType}
        allTypes={this.props.allTypes}
      />
    );
  }
}

const mapStateToProps = state => ({
  selectedType: getSelectedResearchType(state),
  defaultType: getDefaultResearchType(state),
  allTypes: getResearchTypes(state),
  seoDb: getSelectedWebsiteRegionalDatabase(state)
});

export default connect(mapStateToProps, { changeSelectedResearchType })(KeywordResearchSuggestions);
